import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from '../environments/environment';
import { AuthLifecycleStorageService } from './core/services/auth-lifecycle-storage.service';
import { EventTrackerService } from './core/services/event-tracker.service';
import { LanguageService } from './core/services/language.service';
import { RouteCheckerService } from './core/services/route-checker.service';
import { UserConfigurationService } from './core/services/user-configuration.service';
import { MapLoaderService } from './shared/components/maps/services/map-loader.service';
import { MigrationDataDialogService } from './shared/components/migration-data-dialog/migration-data-dialog.service';
import { Languages } from './shared/enums/languages.enum';
import { ThemeService } from './whitelabel/services/theme.service';

@Component({
  selector: 'osp-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  public title = 'frontend-revolution';
  public isPublicRoute = this.routeCheckerService.isPublicRoute();
  public isTheftProtectionAlarmRoute = this.routeCheckerService.isTheftProtectionAlarmRoute();

  constructor(
    private primengConfig: PrimeNGConfig,
    private languageService: LanguageService,
    private mapLoaderService: MapLoaderService,
    private titleService: Title,
    private routeCheckerService: RouteCheckerService,
    private themeService: ThemeService, // injection is needed so that all subpages have access to theme
    private migrationDataDialogService: MigrationDataDialogService,
    private authLifecycleStorageService: AuthLifecycleStorageService,
    private eventTrackerService: EventTrackerService,
    private userConfigurationService: UserConfigurationService,
  ) {
    this.setTitleAndFavicon();
    this.languageService.setDefaultLanguage(environment.FALLBACK_LANGUAGE ?? Languages.EN);
    if (this.authLifecycleStorageService.isJustAuthenticated) {
      this.trackEventLogin();
    }
  }
  ngOnInit() {
    this.primengConfig.ripple = true;
    this.mapLoaderService.initialize();
    this.migrationDataDialogService.startMigrationOnInit();
  }

  private setTitleAndFavicon() {
    this.titleService.setTitle(environment.PAGE_TITLE);
    this.setFavicon(environment.PAGE_FAVICON);
  }

  setFavicon(url: string) {
    const link: HTMLLinkElement = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = url;
    document.head.appendChild(link);
  }

  private trackEventLogin(): void {
    const customerName = this.userConfigurationService.getCustomerName();
    this.eventTrackerService.trackLogin(customerName);
  }

}
